{
  "documentTitle": "Rejoignez votre équipe dans Salt",
  "heading": "Rejoignez votre équipe",
  "instructions": "Vous avez été invité à servir dans une équipe de bénévoles. Téléchargez l'application Salt pour accepter votre invitation.",
  "steps": {
    "download": "Téléchargez l'application Salt",
    "reopen": "Appuyez à nouveau sur le lien d'invitation dans l'e-mail",
    "signIn": "Connectez-vous avec votre adresse e-mail pour rejoindre l'équipe"
  }
}
